import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
/* eslint jsx-a11y/no-redundant-roles: 0 */
import React, { Component } from 'react';
import classNames from 'classnames';
import Container from "@scentregroup/ui/components/container";
import Heading from "@scentregroup/ui/components/heading";
import { uniqueId } from 'lodash';
import { Link } from '@scentregroup/shared/link';
import DeckScrollWrapper from '../deck-scroll-wrapper';
import showWhatsOnFilter from '../../helpers/show-whats-on-filter/index';
import analyticsUtils from '../../helpers/analytics-utils';
import { rangesForDate } from '../../helpers/time-ranges';
import { getNowInCentreInDateFormat } from '../../helpers/date-helpers';
import { CONFIG_KEYS, getClientConfigBool } from '../../config';
import style from './index.module.scss';
import DeckCard from './deck-card';
import { trackDeckCTAClick, trackDeckDateRangeClick, trackPromotionClickEvent } from './analytics';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class Deck extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", {
      selectedFilter: ''
    });
    _defineProperty(this, "isWhatsHappeningFiltersEnabled", getClientConfigBool(CONFIG_KEYS.NEXT_PUBLIC_TOGGLE_WHATS_ON_DECK_FILTERS));
    _defineProperty(this, "trackVisibleItems", items => {
      const cards = items.map(c => c.props);
      const promotions = cards.map(i => ({
        id: i.id,
        name: i.title,
        position: analyticsUtils.positions.WHATS_HAPPENING_CENTRE,
        dimension90: analyticsUtils.dimensions.DIMENSION90,
        creative: i.body
      }));
      analyticsUtils.gaTagTracking({
        event: analyticsUtils.events.PROMOTION_IMPRESSION,
        ecommerce: {
          promoView: {
            promotions
          }
        }
      });
    });
  }
  componentDidMount() {
    const {
      children
    } = this.props;
    if (children && children.length && !getClientConfigBool(CONFIG_KEYS.NEXT_PUBLIC_FEAT_FLAG_MEASUREMENT)) {
      this.trackVisibleItems(children);
    }
  }
  render() {
    const {
      children,
      color,
      title,
      centre,
      callToActionLabel,
      callToActionAddress,
      padded = false
    } = this.props;
    const {
      selectedFilter
    } = this.state;
    const id = uniqueId('deck-');
    const whatsOnContentId = 'whats-on-content';
    const showCTA = callToActionLabel && callToActionAddress;
    const ranges = rangesForDate(getNowInCentreInDateFormat(centre.timeZone), selectedFilter);
    return /*#__PURE__*/_jsxs(Container, {
      centred: true,
      type: "large",
      className: classNames(style.deckContainer, style.evolved),
      "data-id": "deck_index_Container",
      children: [/*#__PURE__*/_jsx(Heading, {
        type: "small",
        className: style.heading,
        id: id,
        "data-id": "deck_index_Container_Heading",
        children: title
      }), this.isWhatsHappeningFiltersEnabled && centre && showWhatsOnFilter(centre.status) && /*#__PURE__*/_jsx("div", {
        className: style.deckFiltersContainer,
        "data-id": "deck_index_div",
        children: /*#__PURE__*/_jsx("div", {
          "aria-controls": whatsOnContentId,
          className: style.whatsOnNav,
          "data-id": "deck_index_div_div_3",
          children: ranges.map(entry => /*#__PURE__*/_jsx(Link, {
            className: style.filterLinks,
            to: "/".concat(centre.slug, "/whats-happening?range=").concat(entry.slug()),
            onClick: () => trackDeckDateRangeClick(entry.name),
            "data-id": "deck_index_Link",
            children: entry.name
          }, entry.slug()))
        })
      }), /*#__PURE__*/_jsx(DeckScrollWrapper, {
        className: style.contentWrapper,
        bgColor: color,
        eventCategory: analyticsUtils.categories.WHATS_HAPPENING_CENTER,
        eventAction: analyticsUtils.actions.CLICK,
        "data-id": "deck_index_Container_DeckScrollWrapper",
        children: /*#__PURE__*/_jsx("ol", {
          className: style.deckCardList,
          "aria-labelledby": id,
          role: "list",
          "data-id": "deck_index_DeckScrollWrapper_ol",
          children: React.Children.map(children, child => /*#__PURE__*/React.cloneElement(child, {
            className: style.deckCard,
            onClick: () => trackPromotionClickEvent(child.props),
            padded
          }))
        })
      }), showCTA && centre && /*#__PURE__*/_jsx("div", {
        className: style.callToActionLink,
        "data-id": "deck_index_div",
        children: /*#__PURE__*/_jsx(Link, {
          to: "/".concat(centre.slug, "/").concat(callToActionAddress),
          onClick: () => trackDeckCTAClick(callToActionLabel),
          "data-id": "deck_index_div_Link",
          children: callToActionLabel
        })
      })]
    });
  }
}
export { Deck, DeckCard };